import React, { FunctionComponent, useEffect, useState } from 'react';
import Icons from '../../Icons';
import { ProductViewer } from '@dp/product-customizer-components';
import { getHostApi } from '../../../../utils';
import { getShopRefInStorage, getUserId } from '../../MonCompteAction';
import Modal from 'react-responsive-modal';
import { Model3dViewData } from '../../iMonCompte';
import { ProductViewerRef } from '@dp/product-customizer-components/dist/src/ProductViewer/ProductViewer.types';

export interface Model3dViewProps {
  panier: Model3dViewData;
  idCommande: number;
  numCommande: string;
  linkVersion?: boolean;
  glbVersion?: number | null;
  loading?: boolean;
  mesBatView?: boolean;
  enabledPostProcessing?: boolean;
}

interface RenderProductViewerProps {
  id: string;
  panier: Model3dViewData;
  texture: string | null;
  loading?: boolean;
  enabledPostProcessing?: boolean;
  allowAllCameraOptions?: boolean;
}

const Model3dView: FunctionComponent<Model3dViewProps> = ({ panier, idCommande, numCommande, linkVersion, glbVersion, loading, mesBatView, enabledPostProcessing }) => {
  const [modalIsOpen,setModalIsOpen] = useState<boolean>(false);
  const textureUrl = glbVersion !== null ? `${getHostApi()}/customers/${getUserId()}/orders/${idCommande}/image-files?nom=${panier.creation_id}.webp&numCommande=${numCommande}&path=travail.auto/textures/&validated=true&xsrf=${localStorage.getItem('xsrfToken')}&cache=${glbVersion}` : null;
  const textureUrlSource = `${getHostApi()}/customers/${getUserId()}/orders/${idCommande}/image-files?nom=${panier.creation_id}-source.webp&numCommande=${numCommande}&path=travail.auto/textures/&validated=true&xsrf=${localStorage.getItem('xsrfToken')}&cache=${glbVersion}`;
  const baseId = `model3dView-${numCommande}-${panier.creation_id}`;

  return (
      <>
        {!linkVersion ? (
          <div className='d-flex pl1 pr1 bg-lightgrey justify-around'>
            <div className='d-flex flex-column justify-content-center'>
              <div className={`containerModel3dView ${mesBatView ? 'heightModel3d' : ''}`}>
                <RenderProductViewer
                  id={baseId}
                  panier={panier}
                  texture={textureUrl}
                  loading={loading}
                  enabledPostProcessing={false}
                />
              </div>
              <div className='bold text-underline text-center w100'>
                <Icons icon="ic-fullscreen" size={25} color="#000" className="mr-1"/>
                <span className='cursor-pointer' onClick={() => setModalIsOpen(true)}>Plein écran</span>
              </div>
            </div>
          </div>
        ) : (
          <span> - <span className='cursor-pointer text-underline' onClick={() => setModalIsOpen(true)}>Afficher le model 3D initial</span></span>
        )}
        <Modal
          center
          classNames={{overlay: 'bootstrap-container', modal: 'containerModel3dViewModal', closeButton: 'closeButton'}}
          open={modalIsOpen}
          onClose={() => setModalIsOpen(false)}
        >
          <RenderProductViewer
            id={`${baseId}-modal`}
            panier={panier}
            texture={linkVersion ? textureUrlSource : textureUrl}
            loading={loading}
            enabledPostProcessing={enabledPostProcessing}
            allowAllCameraOptions
          />
        </Modal>
      </>
  );
};

const RenderProductViewer: FunctionComponent<RenderProductViewerProps> = ({ id, panier, texture, loading, enabledPostProcessing, allowAllCameraOptions}): JSX.Element => {
  const [canChangeAngle, setCanChangeAngle] = useState<boolean>(false);

  useEffect(() => {
    setCanChangeAngle(true);
  }, []);

  const changeAngle = (productViewerRef: ProductViewerRef | null): void => {
    if (productViewerRef && panier.marquages && panier.marquages.length > 0 && canChangeAngle) {
      const angle = panier.marquages.reduce(
        (previous, current): number => previous < current.angle_3d ? previous : current.angle_3d,
        360
      );
      if (angle % 360 !== 0) {
        productViewerRef.setAngle(angle);
      }
    }
  };

  const host = getShopRefInStorage() === 'TH' ? getHostApi() : '';

  return (
    <ProductViewer
      ref={changeAngle}
      domId={id}
      glbUrl={`${host}/model/${panier.article?.produit.idProduits}.xs3p`}
      colorId={panier.article?.couleur?.idCouleursArticles}
      primaryColor={`#${panier.article?.couleur?.code1}`}
      textureUrl={texture}
      loading={loading}
      enabledPostProcessing={enabledPostProcessing}
      allowAllCameraOptions={allowAllCameraOptions}
    />
  );
};

export default Model3dView;